<template>
  <div>
    <el-table
        :data="pinnacleInfo"
        style="width: 100%"
        max-height="250">
        <el-table-column
          prop="name"
          label="名称"
          v-if="tag=='none'"
         >
        </el-table-column>
        <el-table-column
          prop="time"
          label="时间"
          v-if="tag=='two'"
         >
        </el-table-column>
        <el-table-column
          prop="total"
          label="总电量(kwh)"
         >
        </el-table-column>
        <el-table-column label="尖电量">
          <el-table-column
            prop="sum_tip"
            label="电量(kwh)"
            >
          </el-table-column>
          <el-table-column 
            label="电量占比(%)" 
            prop="percentage_tip"                                                  
            >
            <template slot-scope="scope">
                <span>{{scope.row.percentage_tip=='NaN'?0:scope.row.percentage_tip}}</span>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="峰电量">
          <el-table-column
            prop="sum_peak"
            label="电量(kwh)"
            >
          </el-table-column>
          <el-table-column 
            label="电量占比(%)" 
            prop="percentage_peak" 
            >
            <template slot-scope="scope">
                <span>{{scope.row.percentage_peak=='NaN'?0:scope.row.percentage_peak}}</span>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column
            prop="city"
            label="平电量"
            >
            <el-table-column
            prop="sum_level"
            label="电量(kwh)"
            >
          </el-table-column>
          <el-table-column 
            label="电量占比(%)" 
            prop="percentage_level" 
            >
            
            <template slot-scope="scope">
                <span>{{scope.row.percentage_level=='NaN'?0:scope.row.percentage_level}}</span>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column
              prop="province"
              label="谷电量"
              >
              <el-table-column
            prop="sum_valley"
            label="电量(kwh)"
            >
          </el-table-column>
          <el-table-column 
            label="电量占比(%)" 
            prop="percentage_valley" 
            >
            
            <template slot-scope="scope">
                <span>{{scope.row.percentage_valley=='NaN'?0:scope.row.percentage_valley}}</span>
            </template>
          </el-table-column>
        </el-table-column>
      </el-table>
    
  </div>
</template>


<script>
  export default {
    props:{
      routeName:String,
      tag:String,
      pinnacleInfo:Array

    },
    data() {
      return {
        
      }
    },
    created(){
      
    }
  }
</script>

<style  scoped lang="less">
  
</style>